"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Retriable = void 0;

var _axios = require("axios");

var _index = require("../index");

var _uuidv = _interopRequireDefault(require("uuidv4"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Retriable = /*#__PURE__*/function () {
  function Retriable() {
    _classCallCheck(this, Retriable);

    _defineProperty(this, "_debug", false);

    _defineProperty(this, "_pendingRequests", []);
  }

  _createClass(Retriable, [{
    key: "request",
    value:
    /**
     * Make request promise retriable with manual cancel of the next retry
     * @see https://github.com/poetic/retryable-promise
     * @param {function} fn request function to retry on fail, returns Promise
     * @param {Object[]} params Special options
     * @returns {Promise}
     */
    function request(fn) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _getConfig = (0, _index.getConfig)(),
          REQUEST_RETRY_COUNT = _getConfig.REQUEST_RETRY_COUNT,
          REQUEST_RETRY_DELAY = _getConfig.REQUEST_RETRY_DELAY;

      var requestId = params.requestId,
          requestGroup = params.requestGroup; // cancel duplicating retriable with unique id

      if (requestId && this.isPending(requestId)) {
        this.cancel(requestId);
      }

      this.log("new retriable request", requestId || requestGroup);
      var retriesLeft = REQUEST_RETRY_COUNT;

      var retry = function retry() {
        var tryCount = REQUEST_RETRY_COUNT - retriesLeft + 1;

        _this.log("request try #".concat(tryCount), requestId || requestGroup);

        return fn(tryCount)["catch"](function (err) {
          if ((0, _axios.isCancel)(err)) {
            _this.log("request was canceled", requestId || requestGroup);

            return Promise.reject(err);
          }

          retriesLeft--;

          if (retriesLeft === 0) {
            _this.log("request ended with error", requestId || requestGroup);

            return Promise.reject(err);
          }

          var retriableId = requestId ? requestId : requestGroup ? (0, _uuidv["default"])() : null;
          return new Promise(function (resolve, reject) {
            var timeout = function timeout() {
              if (retriableId) {
                if (!_this.isPending(retriableId)) {
                  _this.log("reject retriable with manual Cancel", retriableId);

                  reject(new _axios.Cancel());
                } else {
                  _this.log('proceed to next retry', retriableId);

                  resolve(retry());
                }

                _this.removeRetriable(retriableId);
              } else {
                _this.log('proceed to next retry of retriable');

                resolve(retry());
              }
            };

            var timeoutId = setTimeout(timeout, REQUEST_RETRY_DELAY);

            if (retriableId) {
              _this.addRetriable(_objectSpread({
                retriableId: retriableId,
                timeoutId: timeoutId,
                cancel: timeout
              }, requestGroup ? {
                requestGroup: requestGroup
              } : {}));
            }
          });
        });
      };

      return retry();
    }
    /**
     * Manual cancel of retriable (waiting for delay)
     *
     * @param {string} retriableId requestId or requestGroup
     */

  }, {
    key: "cancel",
    value: function cancel(retriableId) {
      this.log('manual cancel of retriable', retriableId);

      var pendingRequests = this._pendingRequests.filter(function (retriable) {
        return retriable.retriableId === retriableId || retriable.requestGroup === retriableId;
      });

      if (!pendingRequests.length) return;
      this.removeRetriable(retriableId);
      pendingRequests.forEach(function (retriable) {
        if (typeof retriable.cancel === 'function') {
          window.clearTimeout(retriable.timeoutId);
          retriable.cancel();
        }
      });
    }
  }, {
    key: "addRetriable",
    value: function addRetriable(retriable) {
      this.log('adding retriable', retriable.retriableId);

      this._pendingRequests.push(retriable);
    }
  }, {
    key: "removeRetriable",
    value: function removeRetriable(retriableId) {
      this.log('removing retriable', retriableId);
      this._pendingRequests = this._pendingRequests.filter(function (retriable) {
        return retriable.retriableId !== retriableId && retriable.requestGroup !== retriableId;
      });
    }
  }, {
    key: "isPending",
    value: function isPending(retriableId) {
      return !!this._pendingRequests.filter(function (retriable) {
        return retriable.retriableId === retriableId || retriable.requestGroup === retriableId;
      }).length;
    }
  }, {
    key: "log",
    value: function log(message, retriableId) {
      /* eslint-disable-next-line no-console */
      if (this._debug) console.log("".concat(message, " (").concat(retriableId || 'unnamed', ")"));
    }
  }]);

  return Retriable;
}();

exports.Retriable = Retriable;
var retriable = new Retriable();
var _default = retriable;
exports["default"] = _default;